import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const zoneResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getZone(to.params.id as string);
        to.meta.zone = res.data.data;
    } catch(error) {
        console.error('CENTER_RESOLVER_ERROR');
        return { name: 'Zones' };
    }
}